module.exports = __webpack_public_path__ + "static/media/kunals_dilemma.5a1bbc23.pdf";